export class NoInternetError extends Error {
    constructor() {
        super("NO_INTERNET");
        this.name = "NoInternetError";
    }
}

export class RequestTimeoutError extends Error {
    constructor() {
        super("REQUEST_TIMEOUT");
        this.name = "RequestTimeoutError";
    }
}